<template>
	<div class="app-container">
	  <router-view />
	</div>
</template>

<script>
	export default {
	  name: 'Work'
	}
</script>

<style>
</style>
